import { isMobile } from '../../utils';
import { browserDetection } from '../../../../../helpers/Tools';

export let initialSettings = {};

if (window.serverData.data.twilioSettings) {
    try {
        //Due to FrameRate min and max not supported in firefox we are going with another app config.
        const currentBrowserName = browserDetection();
        const isFireFox = currentBrowserName && currentBrowserName === 'Firefox' ? true : false;
        const settings = window && window.serverData && window.serverData.data ?
            isFireFox && window.serverData.data.twilioSettingsForFireFox ? window.serverData.data.twilioSettingsForFireFox : window.serverData.data.twilioSettings : "";
        if (settings) {
            const unescapedSettings = settings.unescapeHTML();
            if (unescapedSettings) {
                initialSettings = JSON.parse(unescapedSettings);
            }
        }
    }
    catch (error) {
        console.log(error);
    }
}

initialSettings = { ...initialSettings };


// This inputLabels object is used by ConnectionOptions.js. It is used to populate the id, name, and label props
// of the various input elements. Using a typed object like this (instead of strings) eliminates the possibility
// of there being a typo.
export const inputLabels = (() => {
    const target = {};
    for (const setting in initialSettings) {
        target[setting] = setting;
    }
    return target;
})();

export function settingsReducer(state, action) {
    return {
        ...state,
        [action.name]: action.value === 'default' ? undefined : action.value
    };
}
